import { NavLink } from "react-router-dom";

type Variant = "teal" | "ink" | "lime";

type Props = {
  children: React.ReactNode;
  target: String;
  /** teal = primary action (default), ink = dark pill (e.g. Sign up), lime = accent */
  variant?: Variant;
};

const variantClasses: Record<Variant, string> = {
  teal: "bg-secondary-400 text-white hover:bg-ink",
  ink: "bg-ink text-sand hover:bg-secondary-400",
  lime: "bg-primary-500 text-ink hover:bg-primary-300",
};

const ActionButton = ({ children, target, variant = "teal" }: Props) => {
  return (
    <NavLink
      className={`inline-flex items-center rounded-full px-5 py-[11px] text-[15px] font-semibold transition-colors duration-300 ${variantClasses[variant]}`}
      to={`${target}`}
    >
      {children}
    </NavLink>
  );
};

export default ActionButton;
